// extracted by mini-css-extract-plugin
export default {"form":"EYPBkWvCK8Pv6NNHqAJE","submit":"ba5KMFRDGChvWm0RTtAi","email":"wENKPj0j4_Vv_HbGJejp","justify":"CRt9dFwD3l8DywnYZZQ3","changePassEmail":"gquVAxHcIYysA9Xy1dKb"};